const formatDateForComparison = (date) => {
  return {
    palindromeTruncated: date.toISOString().slice(0, 10)
  };
};
export {
  formatDateForComparison
};
//# sourceMappingURL=formatDateForComparison.js.map
